<div
  #notificationElement
  class="notification"
  [ngClass]="'notification-' + type"
  [class.cta]="actionLabel"
  [class.has-close]="shouldShowClose"
  [@fadeIn]="animationState"
  tabindex="-1"
  role="alert"
  aria-live="polite"
>
  <ds-icon *ngIf="shouldShowClose" icon="cross" class="close-icon" (click)="close()"></ds-icon>

  <div class="notification-container">
    <ds-icon [icon]="icon" class="icon"></ds-icon>

    <div class="text-container">
      <span class="notification-title">{{ title }}</span>
      <span class="message" [innerHTML]="message"></span>
      <span *ngIf="actionLabel" class="action-label d-block d-md-none d-lg-none" (click)="onAction()">{{
        actionLabel
      }}</span>
    </div>
  </div>
  <div *ngIf="actionLabel" class="d-none d-md-flex d-lg-flex action-container align-items-center">
    <span class="action-label" (click)="onAction()">{{ actionLabel }}</span>
  </div>
</div>
